<template>
  
  <v-autocomplete :multiple="multiple"
    auto-select-first
    chips
    deletable-chips
    :items="tags"
    item-text="name"
    item-value="id"
    :search-input.sync="search"
    v-model="selected"
    :loading="loading"
    >
    <template #append-outer>
        <tag-create @create="addTag" :creating="creating" v-model="menu" />
    </template>
  </v-autocomplete>

</template>

<script>

import TagCreate from '@/components/TagCreate'
import {mapState} from 'vuex'

export default {
    name: 'TagSelector',
    components: {TagCreate},
    props: {
        value: { type: [Array, String ]},
        domain: String,
        multiple: { type: Boolean },
        isDisabled: { type: Function, default: () => false },
        
    },
    data() {
        return {
            search: null,
            selected: this.value,
            menu: false,
            loading: false,
            creating: false,
        }
    },
    watch: {
     selected() {
        this.$emit('input', this.selected);
        this.search=null;
     }   
    },
    computed: {
        items(){
            return this.tags?.filter(t => !this.isDisabled(t))
        },
         ...mapState('contacts', ['tags'])
    },
    methods: {
        async loadTags() {
            this.search=null;
            this.loading = true;
            await this.$store.dispatch('contacts/listTags', { domainID: this.domain, selected: this.value });
            this.loading = false;
        },
        async addTag(newTagName) {
            this.creating = true;
            let nt = await this.$store.dispatch('domains/createTag', { name: newTagName });
            this.creating = false;
            this.menu = false;
            await this.loadTags();
            // selects the new tag automatically
            
            console.debug('automatically selecting the new tag', nt);
            // must find the instqance form the list of the loaded tags - cant pass the new object directly
            //this.clickTag(this.tags.find(t=> t.id == nt.id));
            if(this.multiple) {
                this.selected.push(nt.id);
            } else {
                this.selected = nt.id;
            }
        },
        // not needed
        reset() {
            console.debug('TagAutocomplete resetting - doing nothing');
            //this.tags.forEach(t => t.selected = false;
            this.selected = null;
        }
    },
    mounted() {
        this.loadTags();
    }
}
</script>

